import { useState, type ReactNode } from "react";

export type CalloutKind = "guide" | "quiz" | "mistakes" | "notes" | "code" | "info" | "warn" | "err" | "ok";

// A0: пять типов блоков шага + четыре служебных тона. Цвет — левая
// полоса и тег; фон всегда карточка.
const accent: Record<CalloutKind, string> = {
  guide: "var(--acc)",
  quiz: "var(--info)",
  mistakes: "var(--err)",
  notes: "var(--warn)",
  code: "var(--bd2)",
  info: "var(--info)",
  warn: "var(--warn)",
  err: "var(--err)",
  ok: "var(--ok)",
};

export function Callout({
  kind,
  tag,
  title,
  defaultOpen = true,
  collapsible = true,
  children,
}: {
  kind: CalloutKind;
  tag: string;
  title: ReactNode;
  defaultOpen?: boolean;
  collapsible?: boolean;
  children?: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const color = accent[kind];
  return (
    <section className="overflow-hidden rounded-md border border-bd bg-card" style={{ borderLeft: `2px solid ${color}` }}>
      <button
        type="button"
        onClick={() => collapsible && setOpen((v) => !v)}
        aria-expanded={open}
        className="flex w-full items-center gap-2.5 border-0 bg-transparent px-3.5 py-3 text-left text-ink"
        style={{ cursor: collapsible ? "pointer" : "default" }}
      >
        {/* Тег кода: --bd2 — цвет рамки, для 11px текста не проходит 4.5:1 → --ink2. */}
        <span className="font-mono text-[11px] tracking-[.06em]" style={{ color: kind === "code" ? "var(--ink2)" : color }}>
          {tag}
        </span>
        <span className="flex-1 text-[13.5px] font-semibold">{title}</span>
        {collapsible && (
          <span aria-hidden className="font-mono text-xs text-mut">
            {open ? "−" : "+"}
          </span>
        )}
      </button>
      {open && children && <div className="border-t border-bd px-3.5 pb-3.5 pt-3 text-[13px] leading-[1.55] text-ink2">{children}</div>}
    </section>
  );
}
